"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6071],{

/***/ 49384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CommitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48608);
/* harmony import */ var hooks_useSwitchNetworkLoading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41774);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72978);
/* harmony import */ var hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76166);
/* harmony import */ var _NetworkModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25145);
/* harmony import */ var _Trans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60471);










var wrongNetworkProps = {
    variant: "danger",
    disabled: false,
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Trans__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: "Wrong Network"
    })
};
var CommitButton = function(props) {
    var isWrongNetwork = (0,hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_2__/* .useActiveChainId */ .g)().isWrongNetwork;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,hooks_useSwitchNetworkLoading__WEBPACK_IMPORTED_MODULE_1__/* .useSwitchNetworkLoading */ .c)(), 1), switchNetworkLoading = ref[0];
    var setHideWrongNetwork = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useSetAtom */ .b9)(_NetworkModal__WEBPACK_IMPORTED_MODULE_3__/* .hideWrongNetworkModalAtom */ .v);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        onClick: function(e) {
            if (isWrongNetwork) {
                setHideWrongNetwork(false);
            } else {
                var ref;
                (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
            }
        }
    }), switchNetworkLoading && {
        disabled: true
    }, isWrongNetwork && wrongNetworkProps));
};


/***/ }),

/***/ 82708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ZapCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7887);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19453);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  place-content: center;\n  background: ",
        ";\n  border-radius: 8px 0px 0px 0px;\n  border: 1px solid ",
        ";\n  border-right: none;\n  width: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ZapCheckBoxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-4a3af06d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ZapCheckbox = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ZapCheckBoxWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            scale: "sm"
        }, props))
    });
};


/***/ }),

/***/ 2904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCurrentBlockTimestamp; }
/* harmony export */ });
/* harmony import */ var _state_multicall_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87070);
/* harmony import */ var _useContract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76269);


// gets the current timestamp from the blockchain
function useCurrentBlockTimestamp() {
    var ref, ref1;
    var multicall = (0,_useContract__WEBPACK_IMPORTED_MODULE_1__/* .useMulticallContract */ .gq)();
    return (ref = (0,_state_multicall_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useSingleCallResult */ .Wk)(multicall, "getCurrentBlockTimestamp")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
}


/***/ }),

/***/ 61558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTransactionDeadline; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43997);
/* harmony import */ var _useCurrentBlockTimestamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2904);



// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    var ttl = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.user.userDeadline;
    });
    var blockTimestamp = (0,_useCurrentBlockTimestamp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (blockTimestamp && ttl) return blockTimestamp.add(ttl);
        return undefined;
    }, [
        blockTimestamp,
        ttl
    ]);
}


/***/ }),

/***/ 54221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sA": function() { return /* binding */ harvestFarm; },
  "qq": function() { return /* binding */ nonBscStakeFarm; },
  "zv": function() { return /* binding */ nonBscUnstakeFarm; },
  "AQ": function() { return /* binding */ stakeFarm; },
  "dU": function() { return /* binding */ unstakeFarm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(72558);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(7599);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/utils/bigNumber.ts
var bigNumber = __webpack_require__(81834);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 28 modules
var contractHelpers = __webpack_require__(80405);
;// CONCATENATED MODULE: ./src/views/Farms/hooks/getNonBscVaultFee.ts






var MessageTypes;
(function(MessageTypes) {
    MessageTypes[MessageTypes["Deposit"] = 0] = "Deposit";
    MessageTypes[MessageTypes["Withdraw"] = 1] = "Withdraw";
    MessageTypes[MessageTypes["EmergencyWithdraw"] = 2] = "EmergencyWithdraw";
    MessageTypes[MessageTypes["Claim"] = 3] = "Claim";
})(MessageTypes || (MessageTypes = {}));
var Chains;
(function(Chains) {
    Chains[Chains["EVM"] = 0] = "EVM";
    Chains[Chains["BSC"] = 1] = "BSC";
})(Chains || (Chains = {}));
var COMPENSATION_PRECISION = 1e5;
var ORACLE_PRECISION = 1e18;
var BNB_CHANGE = 5000000000000000;
var BUFFER = 1.3;
var WITHDRAW_BUFFER = 1.4;
var getNonBscVaultContractFee = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var pid, amount, chainId, userAddress, messageType, oraclePrice, gasPrice, nonBscVaultContract, crossFarmingAddress, exchangeRate, getNonce, nonce, ref, encodeMessage, hasFirstTime, estimateGaslimit, calcFee, msgBusFee, destTxFee, totalFee, depositFee, estimateEvmGaslimit, fee, total, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pid = param.pid, amount = param.amount, chainId = param.chainId, userAddress = param.userAddress, messageType = param.messageType, oraclePrice = param.oraclePrice, gasPrice = param.gasPrice;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    nonBscVaultContract = (0,contractHelpers/* getNonBscVaultContract */.aM)(null, chainId);
                    crossFarmingAddress = (0,contractHelpers/* getCrossFarmingSenderContract */.bd)(null, chainId);
                    exchangeRate = new bignumber/* default */.Z(ORACLE_PRECISION).div(oraclePrice).times(ORACLE_PRECISION) // invert into BNB/ETH price
                    ;
                    return [
                        4,
                        crossFarmingAddress.nonces(userAddress, pid)
                    ];
                case 2:
                    getNonce = _state.sent();
                    nonce = new bignumber/* default */.Z(getNonce.toString()).toJSON();
                    return [
                        4,
                        Promise.all([
                            nonBscVaultContract.encodeMessage(userAddress, pid, amount, messageType, nonce),
                            crossFarmingAddress.is1st(userAddress),
                            crossFarmingAddress.estimateGaslimit(Chains.BSC, userAddress, messageType)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), encodeMessage = ref[0], hasFirstTime = ref[1], estimateGaslimit = ref[2];
                    return [
                        4,
                        nonBscVaultContract.calcFee(encodeMessage)
                    ];
                case 4:
                    calcFee = _state.sent();
                    msgBusFee = new bignumber/* default */.Z(calcFee.toString());
                    destTxFee = new bignumber/* default */.Z(gasPrice).times(estimateGaslimit.toString()).times(exchangeRate).times(COMPENSATION_PRECISION).div(new bignumber/* default */.Z(ORACLE_PRECISION).times(COMPENSATION_PRECISION));
                    totalFee = new bignumber/* default */.Z(msgBusFee).plus(destTxFee);
                    if (!hasFirstTime) {
                        depositFee = new bignumber/* default */.Z(BNB_CHANGE).times(exchangeRate).div(ORACLE_PRECISION);
                        return [
                            2,
                            totalFee.plus(depositFee).times(BUFFER).toFixed(0)
                        ];
                    }
                    if (!(messageType >= MessageTypes.Withdraw)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        crossFarmingAddress.estimateGaslimit(Chains.EVM, userAddress, messageType)
                    ];
                case 5:
                    estimateEvmGaslimit = _state.sent();
                    fee = msgBusFee.times(exchangeRate).div(ORACLE_PRECISION);
                    total = new bignumber/* default */.Z(gasPrice).times(estimateEvmGaslimit.toString()).plus(fee);
                    return [
                        2,
                        totalFee.plus(total).times(WITHDRAW_BUFFER).toFixed(0)
                    ];
                case 6:
                    return [
                        2,
                        totalFee.times(BUFFER).toFixed(0)
                    ];
                case 7:
                    error = _state.sent();
                    console.error("Failed to fetch non BscVault fee", error);
                    return [
                        2,
                        bigNumber/* BIG_ZERO.toJSON */.HW.toJSON()
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function getNonBscVaultContractFee(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/farms.ts







var options = {
    gasLimit: config/* BOOSTED_FARM_GAS_LIMIT */.ZM
};
var stakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(masterChefContract, pid, amount, gasPrice) {
        var value;
        return (0,tslib_es6.__generator)(this, function(_state) {
            value = new bignumber/* default */.Z(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
            return [
                2,
                masterChefContract.deposit(pid, value, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function stakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var unstakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(masterChefContract, pid, amount, gasPrice) {
        var value;
        return (0,tslib_es6.__generator)(this, function(_state) {
            value = new bignumber/* default */.Z(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
            return [
                2,
                masterChefContract.withdraw(pid, value, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function unstakeFarm(masterChefContract, pid, amount, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var harvestFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(masterChefContract, pid, gasPrice) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                masterChefContract.deposit(pid, "0", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                    gasPrice: gasPrice
                }))
            ];
        });
    });
    return function harvestFarm(masterChefContract, pid, gasPrice) {
        return _ref.apply(this, arguments);
    };
}();
var nonBscStakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        var value, totalFee;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    value = new bignumber/* default */.Z(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return [
                        4,
                        getNonBscVaultContractFee({
                            pid: pid,
                            chainId: chainId,
                            gasPrice: gasPrice,
                            oraclePrice: oraclePrice,
                            amount: value,
                            userAddress: account,
                            messageType: MessageTypes.Deposit
                        })
                    ];
                case 1:
                    totalFee = _state.sent();
                    console.info(totalFee, "stake totalFee");
                    return [
                        2,
                        contract.deposit(pid, value, {
                            value: totalFee
                        })
                    ];
            }
        });
    });
    return function nonBscStakeFarm(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var nonBscUnstakeFarm = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        var value, totalFee;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    value = new bignumber/* default */.Z(amount).times(config/* DEFAULT_TOKEN_DECIMAL */.o3).toString();
                    return [
                        4,
                        getNonBscVaultContractFee({
                            pid: pid,
                            chainId: chainId,
                            gasPrice: gasPrice,
                            oraclePrice: oraclePrice,
                            amount: value,
                            userAddress: account,
                            messageType: MessageTypes.Withdraw
                        })
                    ];
                case 1:
                    totalFee = _state.sent();
                    console.info(totalFee, "unstake totalFee");
                    return [
                        2,
                        contract.withdraw(pid, value, {
                            value: totalFee
                        })
                    ];
            }
        });
    });
    return function nonBscUnstakeFarm(contract, pid, amount, gasPrice, account, oraclePrice, chainId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 72179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zj": function() { return /* reexport */ callWithEstimateGas; },
  "yp": function() { return /* reexport */ getActivePools; },
  "sA": function() { return /* reexport */ farms/* harvestFarm */.sA; },
  "qq": function() { return /* reexport */ farms/* nonBscStakeFarm */.qq; },
  "zv": function() { return /* reexport */ farms/* nonBscUnstakeFarm */.zv; },
  "AQ": function() { return /* reexport */ farms/* stakeFarm */.AQ; },
  "dU": function() { return /* reexport */ farms/* unstakeFarm */.dU; }
});

// UNUSED EXPORTS: estimateGas

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(5305);
;// CONCATENATED MODULE: ./src/utils/calls/estimateGas.ts





/**
 * Estimate the gas needed to call a function, and add a 10% margin
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param gasMarginPer10000 The gasMargin per 10000 (i.e. 10% -> 1000)
 * @param args An array of arguments to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var estimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _estimateGas, rawGasEstimation, gasEstimation;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, gasMarginPer10000 = _arguments.length > 4 ? _arguments[4] : void 0;
                    if (!contract[methodName]) {
                        throw new Error("Method ".concat(methodName, " doesn't exist on ").concat(contract.address));
                    }
                    return [
                        4,
                        (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                            overrides
                        ]))
                    ];
                case 1:
                    rawGasEstimation = _state.sent();
                    gasEstimation = (0,utils/* calculateGasMargin */.yC)(rawGasEstimation, gasMarginPer10000);
                    return [
                        2,
                        gasEstimation
                    ];
            }
        });
    });
    return function estimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Perform a contract call with a gas value returned from estimateGas
 * @param contract Used to perform the call
 * @param methodName The name of the method called
 * @param methodArgs An array of arguments to pass to the method
 * @param overrides An overrides object to pass to the method
 * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
 */ var callWithEstimateGas = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contract, methodName, methodArgs) {
        var overrides, gasMarginPer10000, _contract, gasEstimation, tx;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, gasMarginPer10000 = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 1000;
                    return [
                        4,
                        estimateGas(contract, methodName, methodArgs, overrides, gasMarginPer10000)
                    ];
                case 1:
                    gasEstimation = _state.sent();
                    return [
                        4,
                        (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(methodArgs).concat([
                            (0,_object_spread/* default */.Z)({
                                gasLimit: gasEstimation
                            }, overrides)
                        ]))
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        2,
                        tx
                    ];
            }
        });
    });
    return function callWithEstimateGas(contract, methodName, methodArgs) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/calls/farms.ts + 1 modules
var farms = __webpack_require__(54221);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(72558);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(73486);
// EXTERNAL MODULE: ./src/config/abi/sousChefV2.json
var sousChefV2 = __webpack_require__(9022);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(25152);
// EXTERNAL MODULE: ./src/utils/providers.ts
var providers = __webpack_require__(11536);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(70627);
;// CONCATENATED MODULE: ./src/utils/calls/pools.ts
/* eslint-disable import/prefer-default-export */ 









/**
 * Returns the total number of pools that were active at a given block
 */ var getActivePools = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(block) {
        var eligiblePools, blockNumber, _tmp, startBlockCalls, endBlockCalls, ref, startBlocks, endBlocks;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eligiblePools = pools/* default.filter */.ZP.filter(function(pool) {
                        return pool.sousId !== 0;
                    }).filter(function(pool) {
                        return pool.isFinished === false || pool.isFinished === undefined;
                    });
                    _tmp = block;
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        providers/* bscRpcProvider.getBlockNumber */.v.getBlockNumber()
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    blockNumber = _tmp;
                    startBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "startBlock"
                        };
                    });
                    endBlockCalls = eligiblePools.map(function(param) {
                        var contractAddress = param.contractAddress;
                        return {
                            address: (0,addressHelpers/* getAddress */.Kn)(contractAddress, 56),
                            name: "bonusEndBlock"
                        };
                    });
                    return [
                        4,
                        Promise.all([
                            (0,multicall/* default */.Z)(sousChefV2, startBlockCalls),
                            (0,multicall/* default */.Z)(sousChefV2, endBlockCalls)
                        ])
                    ];
                case 3:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), startBlocks = ref[0], endBlocks = ref[1];
                    return [
                        2,
                        eligiblePools.reduce(function(accum, poolCheck, index) {
                            var startBlock = startBlocks[index] ? new bignumber/* default */.Z(startBlocks[index]) : null;
                            var endBlock = endBlocks[index] ? new bignumber/* default */.Z(endBlocks[index]) : null;
                            if (!startBlock || !endBlock) {
                                return accum;
                            }
                            if (startBlock.gte(blockNumber) || endBlock.lte(blockNumber)) {
                                return accum;
                            }
                            return (0,_to_consumable_array/* default */.Z)(accum).concat([
                                poolCheck
                            ]);
                        }, [])
                    ];
            }
        });
    });
    return function getActivePools(block) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/calls/index.ts





/***/ }),

/***/ 50288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getLPSymbol; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90902);

var getLPSymbol = function(token0Symbol, token1Symbol, chainId) {
    if (token0Symbol === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .WNATIVE */ .FX[chainId].symbol) {
        return "".concat(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .NATIVE */ .B5[chainId].symbol, "-").concat(token1Symbol, " LP");
    }
    if (token1Symbol === _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .WNATIVE */ .FX[chainId].symbol) {
        return "".concat(token0Symbol, "-").concat(_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .NATIVE */ .B5[chainId].symbol, " LP");
    }
    return "".concat(token0Symbol, "-").concat(token1Symbol, " LP");
};


/***/ }),

/***/ 38662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ transactionErrorToUserReadableMessage; }
/* harmony export */ });
/**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 * @param t Translation function
 */ function transactionErrorToUserReadableMessage(error, t) {
    var reason;
    while(error){
        var ref, ref1;
        var _reason, ref2, ref3;
        reason = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : reason;
        var _error;
        // eslint-disable-next-line no-param-reassign
        error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("Token have transfer fee")) !== -1) {
        return t("This transaction will not succeed due to approve state on transfer. Please try again.");
    }
    console.log("reason", reason);
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    switch(reason){
        case "PancakeRouter: EXPIRED":
            return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
        case "PancakeRouter: INSUFFICIENT_OUTPUT_AMOUNT":
        case "PancakeRouter: EXCESSIVE_INPUT_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_A_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_B_AMOUNT":
            return t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.");
        case "TransferHelper: TRANSFER_FROM_FAILED":
            return t("The input token cannot be transferred. There may be an issue with the input token.");
        case "Pancake: TRANSFER_FAILED":
            return t("The output token cannot be transferred. There may be an issue with the output token.");
        default:
            if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                console.error(error, reason);
                return t("An error occurred when trying to execute this operation. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
            }
            return t("Unknown error%reason%. Try increasing your slippage tolerance.", {
                reason: reason ? ': "'.concat(reason, '"') : ""
            });
    }
}


/***/ }),

/***/ 97794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ZapErrorMessages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22723);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13670);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76660);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76903);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48608);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65957);




var ZapErrorMessages = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(param) {
    var isSingleToken = param.isSingleToken, zapMode = param.zapMode, toggleZapMode = param.toggleZapMode, onModalDismiss = param.onModalDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var toastInfo = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* .useToast */ .p)().toastInfo;
    var handleCloseButton = function() {
        onModalDismiss();
        if (zapMode) {
            toggleZapMode(!zapMode);
            toastInfo(t("Info"), t("Temporarily disabled Zap"));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        margin: "auto",
        width: [
            "100%",
            "100%",
            "380px"
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            variant: "warning",
            mb: "16px",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .Y, {
                        bold: true,
                        children: t("Currently using Zap for liquidity provisions.")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* .MessageText */ .Y, {
                        small: true,
                        children: [
                            isSingleToken ? t("Zap does NOT support tokens with fees on transfers. If you experience any issues, click") : t("Zap does NOT support tokens with fees on transfers. Please choose ’Don't convert’ and retry. If you experience any further issues, click"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                p: "0 4px",
                                scale: "sm",
                                variant: "text",
                                height: "auto",
                                onClick: handleCloseButton,
                                children: t("here")
                            }),
                            t("to disable Zap temporarily.")
                        ]
                    })
                ]
            })
        })
    });
});


/***/ })

}]);